import React, { createContext, useContext } from 'react';
import type { MaitreController } from './useMaitreController';

const MaitreContext = createContext<MaitreController | null>(null);

/** One maître d'AI for the whole app: panel, home and every "Ask about this". */
export function MaitreProvider({
  value,
  children,
}: {
  value: MaitreController;
  children: React.ReactNode;
}) {
  return <MaitreContext.Provider value={value}>{children}</MaitreContext.Provider>;
}

export function useMaitre(): MaitreController {
  const ctx = useContext(MaitreContext);
  if (!ctx) throw new Error('useMaitre must be used within MaitreProvider');
  return ctx;
}

/** For components that also render outside Ops Command (tests, previews). */
export function useMaitreOptional(): MaitreController | null {
  return useContext(MaitreContext);
}
